import React, { useState } from 'react';
import styled from 'styled-components';
import images from '_images';

const GroupItemContainer = styled.div`
  width: 100%;
  position: relative;
  min-height: 50px;
  height: 50px;
  overflow: hidden;
  border-bottom: 1px solid #dcdcdc;

  &.expanded {
    min-height: auto;
    height: auto;
  }
`;

const MaterialItemLetterButton = styled.button`
  position: relative;
  min-height: 50px;
  height: 50px;
  background: transparent;
  border: none;
  font-size: 20px !important;
   
  width: 100%;
  text-align: left;
  cursor: pointer;
  padding-left: 2px;
  outline: none;

  &:focus {
    outline: none;
  }

  &:before {
    content: '';
    position: absolute;
    right: 20px;
    top: 0;
    bottom: 0;
    opacity: 0.6;
    margin: auto;
    transition: all 0.1s ease-in-out;
    width: 21px;
    height: 21px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${images.icons.blackArrowDown});
  }
  &.expanded {
    &:before {
      transform: rotate(180deg);
    }
  }
`;

const InnerButton = styled.span`
  width: 97%;
  display: block;
  padding: 11px 6px;

  &:focus {
    outline: none;
  }

  ${MaterialItemLetterButton}:focus > & {
    box-shadow: 0 0 2px 2px #51a7e8;
    border-radius: 5px; 
  }
`;

const MaterialGroup = ({
  children, title, isOpen, setIsOpen
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <GroupItemContainer
      className={`${expanded ? 'expanded' : ''}`}
    >
      <MaterialItemLetterButton
        onClick={() => [setIsOpen(!isOpen), setExpanded(!expanded)]}
        className={`${expanded ? 'expanded' : ''}`}
        aria-label="click to expand the list"
        tabIndex="0"
      >
        <InnerButton tabIndex="-1">{title}</InnerButton>
      </MaterialItemLetterButton>
      {children}
    </GroupItemContainer>
  );
};

export default MaterialGroup;
